class OptionCartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault()

      const cartItemTR = this.closest('.cart-item');
      const optionCode = cartItemTR.dataset.option;
      this.updateQuantity(this.dataset.index, 0, optionCode);
    });
  }

  updateQuantity(line, quantity, optionCode) {
    const cartTable = this.closest('.cart-items');
    if (!cartTable) return;
    const cartTableItem = cartTable.querySelectorAll('.cart-item');
    if (!cartTableItem.length) return;

    let quantities = [];
    if (optionCode) {
      cartTableItem.forEach(function(item) {
        if (item.dataset.option === optionCode) {
          quantities.push(quantity);
        } else {
          var q = item.querySelector('input.quantity__input').value;
          quantities.push(q);
        }
      });
    } else {
      cartTableItem.forEach(function(item) {
        if (item.dataset.line === line) {
          quantities.push(quantity);
        } else {
          var q = item.querySelector('input.quantity__input').value;
          quantities.push(q);
        }
      });
      }
    let body = JSON.stringify({ updates: quantities });
    fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }})
    .then((response) => {
      return response.text();
    })
    .then((state) => {
      window.location = '/cart/';
      return;
    }).catch((e) => {
      console.error(e);
    });
  }
}

customElements.define('elusapps-option-cart-remove-button', OptionCartRemoveButton);

class OptionCartChangeQuantity extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.oldValue = this.input.value;
    this.input.addEventListener('change', (event) => {
      event.preventDefault()

      const cartItemTR = this.closest('.cart-item');
      const optionCode = cartItemTR.dataset.option;
      this.updateQuantity(this.dataset.index, event.target.value, optionCode, this.oldValue);
    });
    this.changeEvent = new Event('change', { bubbles: true })
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', (event) => {
        event.preventDefault()
  
        const cartItemTR = this.closest('.cart-item');
        const optionCode = cartItemTR.dataset.option;
        this.onButtonClick(event);
      })
    );
  }

  onButtonClick(event) {
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  updateQuantity(line, quantity, optionCode, oldValue) {
    const cartTable = this.closest('.cart-items');
    if (!cartTable) return;
    const cartTableItem = cartTable.querySelectorAll('.cart-item');
    if (!cartTableItem) return;

    let quantities = [];
    cartTableItem.forEach(function(item) {
      if (optionCode !== "" && item.dataset.option === optionCode) {
        if (item.dataset.type === "option") {
          var v = (item.querySelector('input.quantity__input').value / oldValue) * quantity;
          quantities.push(v);
        } else {
          quantities.push(quantity);
        }
      } else {
        var q = item.querySelector('input.quantity__input').value;
        quantities.push(q);
      }
    });
    let body = JSON.stringify({ updates: quantities });
    fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }})
    .then((response) => {
      return response.text();
    })
    .then((state) => {
      window.location = '/cart/';
      return;
    }).catch((e) => {
      console.error(e);
    });
  }
}

customElements.define('elusapps-option-cart-quantity-input', OptionCartChangeQuantity);
